import { actions } from './actions';
import { mutations } from './mutations';
import { Pagination } from 'packages/core/Pagination';
import { getters } from './getters';
var state = {
    loadingJobList: false,
    loadingLandingPages: false,
    locations: [],
    jobList: null,
    landingPagePagination: new Pagination(),
    jobListNotFound: false,
    landingPages: [],
    privacyPolicyUrl: null,
};
export var jobLists = {
    namespaced: true,
    state: state,
    actions: actions,
    getters: getters,
    mutations: mutations,
};
